/* eslint-disable react/jsx-props-no-spreading */
import { Grid2 as Grid } from "@mui/material";
import TemplateApis from "../apis-section/template-apis";
import TemplateValidRegex from "../regular-expressions/template-valid-regex";
import TemplateReplacementCharacters from "../replacement-characters/template-replacement-characters";
import TemplateReplacementValues from "../replacement-values/template-replacement-values";
import TemplateRoutines from "../routines/template-routines";
import {
  DataTypeInfo,
  ValidCharacterItem,
  AvailableValidCharacterItem,
} from "../types/api-types";
import TemplateValidCharactersList from "../valid-characters/template-valid-characters-list";
import TemplateValidValues from "../valid-values/template-valid-values";

export interface FormData {
  useDataValidator: boolean;
  minLength: number;
  maxLength: number;
  allowLetters: boolean;
  allowNumbers: boolean;
  allowSpaces: boolean;
  allowFutureDates: boolean;
  dataType: DataTypeInfo | null;
  validCharactersList: ValidCharacterItem[];
  validRegexList: string[];
  replacementCharacters: { value: string; replacement: string }[];
  routines: string[];
  validValues: string[];
}

interface TemplateAdvancedConfigProps {
  templateId: number;
  formData: FormData;
  availableValidCharacters: AvailableValidCharacterItem[];
  isLoadingValidCharacters: boolean;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  onSaveValidCharacters: (
    added: ValidCharacterItem[],
    deleted: ValidCharacterItem[],
  ) => Promise<void>;
}

const TemplateAdvancedConfig = ({
  templateId,
  formData,
  availableValidCharacters,
  isLoadingValidCharacters,
  setFormData,
  onSaveValidCharacters,
}: TemplateAdvancedConfigProps) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <TemplateValidValues templateId={templateId} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TemplateValidCharactersList
          validCharactersList={formData.validCharactersList}
          availableValidCharacters={availableValidCharacters}
          isLoadingValidCharacters={isLoadingValidCharacters}
          setFormData={setFormData}
          onSaveCharacters={onSaveValidCharacters}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TemplateValidRegex templateId={templateId} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TemplateReplacementCharacters templateId={templateId} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TemplateReplacementValues templateId={templateId} />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TemplateRoutines templateId={templateId} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TemplateApis templateId={templateId} />
      </Grid>
    </Grid>
  );
};

export default TemplateAdvancedConfig;
